import { Dialog, IconButton } from "@mui/material";
import { useMemo } from "react";
import intl from "react-intl-universal";
import { Link } from "react-router-dom";
import { MdClose } from "react-icons/md";
import { buildBaasAccountDetailPath } from "../../constants";

const tryParseJson = (value) => {
  if (!value || typeof value !== "string") return null;
  const trimmed = value.trim();
  if (!trimmed.startsWith("{") && !trimmed.startsWith("[")) return null;
  try {
    return JSON.parse(trimmed);
  } catch {
    return null;
  }
};

const DetailRow = ({ label, value, mono = false }) => {
  if (value == null || value === "") return null;
  return (
    <div className="flex flex-col gap-0.5 border-b border-gray-100 py-2.5 last:border-b-0 dark:border-brand-dark-border sm:flex-row sm:items-center sm:justify-between sm:gap-4">
      <span className="text-xs text-gray-500 dark:text-gray-400">{label}</span>
      <span
        className={`text-sm font-medium text-brand-dark dark:text-gray-100 sm:text-right ${mono ? "font-mono text-xs break-all" : ""}`}
      >
        {value}
      </span>
    </div>
  );
};

export const BaasPldDetailDrawer = ({ item, onClose }) => {
  const open = Boolean(item);

  const motivoJson = useMemo(
    () => tryParseJson(item?.reason_detail ?? item?.reasonDetail),
    [item?.reason_detail, item?.reasonDetail],
  );

  const accountId = item?.account_id ?? item?.accountId;
  const pixId = item?.pix_id ?? item?.pixId;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="md"
      PaperProps={{ className: "!rounded-2xl !shadow-card app-card !m-4 !max-h-[90vh]" }}
    >
      <div className="flex items-start justify-between gap-3 border-b border-gray-100 px-4 py-4 dark:border-brand-dark-border sm:px-5">
        <div>
          <h2 className="text-lg font-bold text-brand-dark dark:text-gray-100">
            {intl.get("baas.pld.detail.title") || "Detalhe PLD"}
          </h2>
          <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
            {item?.entity_name || item?.entityName || accountId || "—"}
          </p>
        </div>
        <IconButton onClick={onClose} aria-label="Fechar" size="small">
          <MdClose />
        </IconButton>
      </div>

      <div className="max-h-[70vh] overflow-y-auto px-4 py-4 sm:px-5">
        <DetailRow
          label={intl.get("baas.pld.columns.reason") || "Motivo"}
          value={item?.reason_code ?? item?.reasonCode}
        />
        <DetailRow
          label={intl.get("baas.pld.columns.period") || "Período"}
          value={item?.period_type ?? item?.periodType}
        />
        <DetailRow
          label={intl.get("baas.pld.columns.payer") || "Pagador"}
          value={item?.payer_name ?? item?.payerName}
        />
        <DetailRow
          label={intl.get("baas.pld.columns.e2e") || "E2E"}
          value={item?.external_ref ?? item?.externalRef}
          mono
        />
        <DetailRow label="Status pagamento" value={item?.payment_status ?? item?.paymentStatus} />

        {motivoJson ? (
          <div className="mt-4">
            <p className="text-xs font-semibold uppercase tracking-wide text-gray-400">
              {intl.get("baas.pld.detail.motivoJson") || "Motivo (JSON)"}
            </p>
            <pre className="mt-2 max-h-48 overflow-auto rounded-lg bg-gray-50 p-3 text-xs text-gray-700 dark:bg-brand-dark-elevated dark:text-gray-200">
              {JSON.stringify(motivoJson, null, 2)}
            </pre>
          </div>
        ) : (
          <DetailRow
            label={intl.get("baas.pld.detail.motivo") || "Detalhe do motivo"}
            value={item?.reason_detail ?? item?.reasonDetail}
          />
        )}

        <div className="mt-4 flex flex-wrap gap-3">
          {accountId ? (
            <Link
              to={buildBaasAccountDetailPath(accountId)}
              className="text-sm font-semibold text-[#D3A971] no-underline hover:opacity-80"
            >
              {intl.get("baas.pld.detail.openAccount") || "Abrir conta"}
            </Link>
          ) : null}
          {pixId ? (
            <span className="text-sm text-gray-500">
              Pix ID: <span className="font-mono text-xs">{pixId}</span>
            </span>
          ) : null}
          {item?.receiver_pix_key ?? item?.receiverPixKey ? (
            <span className="text-sm text-gray-500">
              Chave: {item?.receiver_pix_key ?? item?.receiverPixKey}
            </span>
          ) : null}
        </div>
      </div>
    </Dialog>
  );
};
